window.BLAtcPriceSync = window.BLAtcPriceSync || {
  owners: new Set(),

  getWrappers() {
    return Array.from(document.querySelectorAll('[data-persistent-btn-price]'));
  },

  hasActiveBundleOwner() {
    return this.owners.size > 0;
  },

  setDefaultPrice(price) {
    if (!price) return;

    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.defaultPrice = price;

      if (this.hasActiveBundleOwner()) return;

      wrapper.dataset.btnPriceSource = 'default';
      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay) {
        priceDisplay.textContent = price;
      }
    });
  },

  applyBundlePrice(owner, price) {
    if (!owner || !price) return;

    this.owners.add(owner);
    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.btnPriceSource = 'bundle';
      wrapper.dataset.bundlePriceOwner = owner;

      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay) {
        priceDisplay.textContent = price;
      }
    });
  },

  clearBundlePrice(owner) {
    if (owner) {
      this.owners.delete(owner);
    }

    if (this.hasActiveBundleOwner()) return;

    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.btnPriceSource = 'default';
      delete wrapper.dataset.bundlePriceOwner;

      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay && wrapper.dataset.defaultPrice) {
        priceDisplay.textContent = wrapper.dataset.defaultPrice;
      }
    });
  },
};

window.BLBundlePriceState = window.BLBundlePriceState || {
  owners: new Map(),

  normalizePriceState(priceState) {
    if (!priceState) return null;

    if (typeof priceState === 'string') {
      return {
        displayPrice: priceState,
        compareAtPrice: '',
        isOnSale: false,
      };
    }

    const displayPrice = priceState.displayPrice || priceState.price || '';
    const compareAtPrice = priceState.compareAtPrice || '';
    const isOnSale = Boolean(priceState.isOnSale || (displayPrice && compareAtPrice));

    if (!displayPrice) return null;

    return {
      displayPrice,
      compareAtPrice,
      isOnSale,
    };
  },

  ensureCSS() {
    if (document.getElementById('bl-bundle-price-state-css')) return;

    const style = document.createElement('style');
    style.id = 'bl-bundle-price-state-css';
    style.textContent = `
      body.wb-addon-active product-info .f-price > *,
      body.wb-addon-active .product__info-container .f-price > * {
        display: none !important;
      }
      body.wb-addon-active sticky-atc-bar .f-price > *,
      body.wb-addon-active .sticky-atc-bar .f-price > * {
        display: none !important;
      }
      .wb-addon-total-price {
        display: none;
        font-weight: 700;
      }
      .product__block--price .wb-addon-total-price {
        font-size: 1.96rem;
        line-height: 2.4rem;
      }
      @media (min-width: 768px) {
        .product__block--price .wb-addon-total-price {
          font-size: 2.8rem;
          line-height: 3.8rem;
        }
      }
      .sticky-atc-bar__product-info .wb-addon-total-price {
        font-size: inherit;
        line-height: inherit;
      }
      .wb-addon-total-price__current,
      .wb-addon-total-price__compare {
        display: inline-flex;
        align-items: center;
      }
      .wb-addon-total-price--sale .wb-addon-total-price__current {
        color: rgb(var(--color-product-price-sale)) !important;
      }
      .wb-addon-total-price__compare {
        margin-inline-start: 0.8rem;
        color: var(--color-product-price-regular, var(--color-foreground-lighten-60)) !important;
        font-size: var(--font-body-size);
        line-height: var(--font-body-line-height);
        font-weight: var(--font-body-weight);
      }
      body.wb-addon-active .wb-addon-total-price {
        display: inline !important;
      }
      body.wb-btn-ready [data-btn-price-wrapper] {
        display: inline-flex !important;
        align-items: center;
        gap: 8px;
        margin-left: 20px;
        z-index: 10;
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        text-transform: inherit;
      }
      .btn__price-separator { opacity: 0.5; font-weight: 300; color: inherit; }
      [data-btn-price-display] { color: inherit; font-weight: inherit; }
      .btn__price-arrow { width: 1em; height: 1em; color: inherit; }
      [data-bl-price-locked] .f-price > * { display: none !important; }
      [data-bl-price-locked] .wb-addon-total-price { display: inline !important; }
    `;
    document.head.appendChild(style);
  },

  setOwnerState(owner, active, { buttonReady = false } = {}) {
    if (!owner) return;

    if (active) {
      this.owners.set(owner, { buttonReady });
    } else {
      this.owners.delete(owner);
    }

    this.syncBodyClasses();
  },

  syncBodyClasses() {
    const hasActiveOwner = this.owners.size > 0;
    const hasButtonReadyOwner = Array.from(this.owners.values()).some((state) => state?.buttonReady);

    document.body.classList.toggle('wb-addon-active', hasActiveOwner);
    document.body.classList.toggle('wb-btn-ready', hasButtonReadyOwner);
  },

  applyPriceNode(priceNode, priceState, { lock = false } = {}) {
    const normalizedState = this.normalizePriceState(priceState);
    if (!priceNode || !normalizedState) return;

    this.ensureCSS();

    const internalContainer = priceNode.querySelector('.f-price');
    if (!internalContainer) return;

    const nodeDocument = priceNode.ownerDocument || document;
    let bundlePriceEl = internalContainer.nextElementSibling;
    if (!bundlePriceEl || !bundlePriceEl.classList.contains('wb-addon-total-price')) {
      bundlePriceEl = nodeDocument.createElement('span');
      bundlePriceEl.className = 'wb-addon-total-price';
      internalContainer.parentNode.insertBefore(bundlePriceEl, internalContainer.nextSibling);
    }

    bundlePriceEl.classList.toggle('wb-addon-total-price--sale', normalizedState.isOnSale);
    bundlePriceEl.innerHTML =
      normalizedState.isOnSale && normalizedState.compareAtPrice
        ? `
        <span class="wb-addon-total-price__current f-price-item f-price-item--sale">${normalizedState.displayPrice}</span>
        <s class="wb-addon-total-price__compare f-price-item f-price-item--regular">${normalizedState.compareAtPrice}</s>
      `
        : `
        <span class="wb-addon-total-price__current f-price-item f-price-item--regular">${normalizedState.displayPrice}</span>
      `;

    if (lock) {
      priceNode.setAttribute('data-bl-price-locked', '');
    } else {
      priceNode.removeAttribute('data-bl-price-locked');
    }
  },

  clearPriceNode(priceNode) {
    if (!priceNode) return;
    priceNode.removeAttribute('data-bl-price-locked');
  },

  formatMoney(cents) {
    const format =
      window.FoxTheme?.settings?.moneyFormat ||
      document.querySelector('[data-money-format]')?.getAttribute('data-money-format') ||
      document.querySelector('[data-money-format]')?.content;
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, format || '${{amount}}');
    }
    // 2026-08-24: el tema NO define Shopify.formatMoney (solo se carga en customers/), asi que la
    // rama real es FoxTheme.Currency con el money_format de la tienda — antes se caia SIEMPRE al
    // fallback es-ES/EUR hardcodeado (formato inconsistente hoy; moneda mal etiquetada si algun
    // dia entra un mercado no-EUR). El toLocaleString queda solo como ultimo recurso.
    if (window.FoxTheme?.Currency?.formatMoney && format) {
      return window.FoxTheme.Currency.formatMoney(cents, format);
    }

    return (cents / 100)
      .toLocaleString('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 })
      .replace(',00', '');
  },

  getRegularComponentPrice(price, compareAtPrice = 0) {
    const normalizedPrice = Number.parseInt(price || 0, 10) || 0;
    const normalizedCompareAtPrice = Number.parseInt(compareAtPrice || 0, 10) || 0;
    return normalizedCompareAtPrice > normalizedPrice ? normalizedCompareAtPrice : normalizedPrice;
  },

  buildPriceState(basePrice, addonPrice, opts = {}) {
    const {
      baseCompareAtPrice = 0,
      addonCompareAtPrice = 0,
      addonRegularPrice = null,
      allowCompareAt = true,
    } = opts;
    const normalizedBasePrice = Number.parseInt(basePrice || 0, 10) || 0;
    const normalizedAddonPrice = Number.parseInt(addonPrice || 0, 10) || 0;
    const total = normalizedBasePrice + normalizedAddonPrice;
    const displayPrice = this.formatMoney(total);
    const baseRegularPrice = this.getRegularComponentPrice(normalizedBasePrice, baseCompareAtPrice);
    const resolvedAddonRegularPrice =
      addonRegularPrice == null
        ? this.getRegularComponentPrice(normalizedAddonPrice, addonCompareAtPrice)
        : Math.max(Number.parseInt(addonRegularPrice || 0, 10) || 0, normalizedAddonPrice);
    const regularTotal = baseRegularPrice + resolvedAddonRegularPrice;
    const compareAtTotal = allowCompareAt && regularTotal > total ? regularTotal : 0;

    return {
      total,
      displayPrice,
      formattedTotal: displayPrice,
      regularTotal,
      baseRegularPrice,
      addonRegularPrice: resolvedAddonRegularPrice,
      compareAtTotal,
      compareAtPrice: compareAtTotal > total ? this.formatMoney(compareAtTotal) : '',
      isOnSale: compareAtTotal > total,
    };
  },
};

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get productMediaWrapper() {
        return (this._productMediaWrapper = this._productMediaWrapper || this.querySelector('.product__media-wrapper'));
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }

        if (this.productMediaWrapper) {
          this.blockPositionHandler = this.handleBlocksPosition.bind(this);
          this.handleBlocksPosition();
          document.addEventListener('matchMobile', this.blockPositionHandler);
          document.addEventListener('unmatchMobile', this.blockPositionHandler);
        }
      }

      handleBlocksPosition() {
        const isMobile = FoxTheme.config.mqlMobile;
        const blocks = this.querySelectorAll(`.product__block[data-show-below-media="true"]`);

        blocks.forEach((block) => {
          const blockId = block.dataset.blockId;
          const blockPlacement = this.productMediaWrapper.querySelector(`[data-block-id="${blockId}"]`);
          if (!blockPlacement) return;

          if (isMobile) {
            const isMoveToMedia = block.hasAttribute('data-moved-below-media');
            if (isMoveToMedia) {
              block.innerHTML = blockPlacement.innerHTML;
              blockPlacement.innerHTML = '';
              block.removeAttribute('data-moved-below-media');
            }
          } else {
            blockPlacement.innerHTML = block.innerHTML;
            block.innerHTML = '';
            block.setAttribute('data-moved-below-media', '');
          }
        });
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      prepareIncomingServerFilteredMedia(incomingMedia, currentMedia) {
        if (!incomingMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]')) return null;

        incomingMedia.dataset.blDeferInit = 'true';

        const currentViewer = currentMedia?.querySelector('[id^="GalleryViewer"]');
        const currentGalleryHeight = currentMedia?.offsetHeight || 0;
        const currentViewerHeight = currentViewer?.offsetHeight || 0;

        incomingMedia.style.opacity = '0';
        incomingMedia.style.pointerEvents = 'none';
        if (currentGalleryHeight > 0) {
          incomingMedia.style.minHeight = `${currentGalleryHeight}px`;
        }

        const incomingViewer = incomingMedia.querySelector('[id^="GalleryViewer"]');
        if (incomingViewer && currentViewerHeight > 0) {
          incomingViewer.style.minHeight = `${currentViewerHeight}px`;
        }

        const incomingThumbnails = incomingMedia.querySelector('[id^="GalleryThumbnails"]');
        if (incomingThumbnails) {
          incomingThumbnails.style.opacity = '0';
          incomingThumbnails.style.pointerEvents = 'none';
        }

        return {
          galleryHeight: currentGalleryHeight,
          viewerHeight: currentViewerHeight,
        };
      }

      postProcessIncomingServerFilteredMedia(newMedia, metrics) {
        if (!newMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]')) return;

        const viewer = newMedia.querySelector('[id^="GalleryViewer"]');
        const thumbnails = newMedia.querySelector('[id^="GalleryThumbnails"]');
        const releaseMask = () => {
          newMedia.style.opacity = '';
          newMedia.style.pointerEvents = '';
          newMedia.style.minHeight = '';
          if (viewer) viewer.style.minHeight = '';
          if (thumbnails) {
            thumbnails.style.opacity = '';
            thumbnails.style.pointerEvents = '';
          }
        };

        newMedia.removeAttribute('data-bl-defer-init');
        if (typeof newMedia.init === 'function' && newMedia.initialized !== true) {
          newMedia.init();
        }
        newMedia.sliderInstance?.slider?.update?.();

        const firstImg = viewer?.querySelector('img');
        let rafAttempts = 0;
        const maxRafAttempts = 24;

        const isImageReady = () => !firstImg || (firstImg.complete && firstImg.naturalHeight > 0);
        const isReady = () => {
          const viewerReady = viewer?.classList.contains('swiper-initialized') || !viewer;
          const thumbsReady = thumbnails?.classList.contains('swiper-initialized') || !thumbnails;
          return viewerReady && thumbsReady && isImageReady();
        };

        const revealWhenStable = () => {
          rafAttempts += 1;
          if (isReady() || rafAttempts >= maxRafAttempts) {
            const slider = newMedia.sliderInstance?.slider;
            if (viewer?.style.minHeight && slider && typeof slider.updateAutoHeight === 'function') {
              slider.updateAutoHeight(0);
            }
            releaseMask();
            return;
          }
          requestAnimationFrame(revealWhenStable);
        };

        requestAnimationFrame(revealWhenStable);
        setTimeout(releaseMask, 1200);
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode)
        });
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.resetFormState();
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            const currentTitle = document.querySelector('head title');
            const incomingTitle = html.querySelector('head title');
            if (currentTitle && incomingTitle) currentTitle.innerHTML = incomingTitle.innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const incomingMedia = html.querySelector(`[id^="MediaGallery-${this.sectionId}"]`);
          const currentMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
          const hasServerFilteredGallery = Boolean(
            incomingMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]'),
          );
          // 2026-10-29: si el servidor manda EXACTAMENTE el mismo juego de slides (misma firma: visibles +
          // anexadas para combos), la galeria se queda como esta. Antes se sustituia siempre, se ocultaba
          // hasta cargar la 1ª foto (hasta 1,2 s) y los selectores volvian a montar su combo: cambiar de
          // medida en un plato o un mueble sin fotos por medida parpadeaba 1-2 s sin cambiar nada.
          const incomingSig = incomingMedia?.dataset?.blMediaSignature;
          const sameGallery = Boolean(
            hasServerFilteredGallery && currentMedia && incomingSig && incomingSig === currentMedia.dataset.blMediaSignature,
          );
          if (sameGallery) {
            // nada: la galeria ya enseña estas fotos
          } else if (incomingMedia && currentMedia && hasServerFilteredGallery) {
            const mediaMetrics = this.prepareIncomingServerFilteredMedia(incomingMedia, currentMedia);
            HTMLUpdateUtility.viewTransition(
              currentMedia,
              incomingMedia,
              this.preProcessHtmlCallbacks,
              [
                ...this.postProcessHtmlCallbacks,
                (newNode) => this.postProcessIncomingServerFilteredMedia(newNode, mediaMetrics),
              ],
            );
          } else {
            this.updateMedia(variant);
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Barcode', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          this.currentVariant = variant;

          // BL 2026-07-29: refresca el precio "default" del chip del botón ATC (y su data-default-price)
          // al cambiar de variante. Sin esto el chip conservaba el precio server-rendered de la carga
          // inicial (p.ej. 513 € de Breite 120 tras bajar a 60 → 370 €); setDefaultPrice ya respeta a los
          // owners de precio bundle (washbasin-v2 / product-addons) y solo pinta si no hay ninguno activo.
          if (window.BLAtcPriceSync?.setDefaultPrice && variant?.price != null) {
            window.BLAtcPriceSync.setDefaultPrice(window.BLBundlePriceState?.formatMoney?.(variant.price) || null);
          }

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant
              }
            })
          );

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant
            }
          });
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        if (!selectedVariant) return null;
        try {
          return JSON.parse(selectedVariant);
        } catch (error) {
          return null;
        }
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const viewportPosition = this.captureViewportPosition();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            this.focusTargetWithoutScroll(targetId, viewportPosition);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      captureViewportPosition() {
        return {
          x: window.scrollX,
          y: window.scrollY,
        };
      }

      restoreViewportPosition(position) {
        if (!position) return;

        const restore = () => {
          if (window.scrollX !== position.x || window.scrollY !== position.y) {
            window.scrollTo(position.x, position.y);
          }
        };

        restore();
        requestAnimationFrame(restore);
      }

      focusTargetWithoutScroll(targetId, viewportPosition) {
        const target = document.getElementById(targetId);

        if (target) {
          try {
            target.focus({ preventScroll: true });
          } catch (error) {
            target.focus();
          }
        }

        this.restoreViewportPosition(viewportPosition);
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;

        const parsedUrl = new URL(url, window.location.origin);

        if (variantId) {
          parsedUrl.searchParams.set('variant', variantId);
        } else {
          parsedUrl.searchParams.delete('variant');
        }

        window.history.replaceState({}, '', parsedUrl);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = FoxTheme.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId
          }
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML
          }
        });

        this.setQuantityBoundries();
      }
    }
  );
}

if (!customElements.get('product-promotion-alert')) {
  customElements.define(
    'product-promotion-alert',
    class ProductPromotionAlert extends HTMLElement {
      constructor() {
        super();

        this.abortController = new AbortController();
        this.buttonEl = this.querySelector('button');
        this.buttonEl.addEventListener('click', this.onClick.bind(this), {
          signal: this.abortController.signal
        });
      }

      onClick(evt) {
        evt.preventDefault();

        this.closest('.product__block').classList.add('hidden');
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}

/* 2026-10-27: the add button shows what it adds: the price (product or whole set) × the quantity picker.
   Several selectors write the price straight into [data-btn-price-display]; whatever any of them wrote
   last is taken as the price of one, and the button's own form gives the quantity. Recordings of 20–25-10:
   «+» on the quantity, button at 407 €, cart at 814 €. */
(() => {
  if (window.BLAtcQuantityPrice) return;
  window.BLAtcQuantityPrice = true;
  const DISPLAY = '[data-btn-price-display]';

  const quantityOf = (display) => {
    const form = display.closest('button')?.form;
    let input = form ? form.elements.namedItem('quantity') : null;
    if (input && !input.tagName && input.length) input = Array.from(input).find((el) => el.type !== 'hidden') || input[0];
    const value = parseInt(input?.value, 10);
    return Number.isFinite(value) && value > 1 ? value : 1;
  };
  // «1,035 €» (no decimals) or «1.035,50 €»: two digits after the last separator are cents.
  const toCents = (text) => {
    const digits = text.replace(/\D/g, '');
    if (!digits) return 0;
    return /\d[.,]\d{2}(?!\d)/.test(text) ? Number(digits) : Number(digits) * 100;
  };
  const render = (display) => {
    const unit = display.dataset.blUnitPrice || '';
    const quantity = quantityOf(display);
    const format = window.FoxTheme?.settings?.moneyFormat;
    const formatMoney = window.FoxTheme?.Currency?.formatMoney;
    const cents = toCents(unit);
    const shown = quantity > 1 && cents && format && formatMoney ? formatMoney(cents * quantity, format) : unit;
    display.dataset.blShownPrice = shown;
    if (display.textContent.trim() !== shown) display.textContent = shown;
  };
  const sync = () => {
    document.querySelectorAll(DISPLAY).forEach((display) => {
      const text = display.textContent.trim();
      if (!text) return;
      // Text this module did not write is a new price of one.
      if (text !== display.dataset.blShownPrice) display.dataset.blUnitPrice = text;
      render(display);
    });
  };
  // A microtask, not requestAnimationFrame: frames stop while the page is not painted (background tab).
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  };
  const isQuantity = (event) => event.target?.name === 'quantity';
  document.addEventListener('change', (event) => { if (isQuantity(event)) schedule(); }, true);
  document.addEventListener('input', (event) => { if (isQuantity(event)) schedule(); }, true);
  // After an add, Hyper's quantity-input sets the value back to its minimum without a change event.
  const subscribe = () => {
    const pubsub = window.FoxTheme?.pubsub;
    if (!pubsub?.subscribe) return false;
    const events = pubsub.PUB_SUB_EVENTS || {};
    [events.quantityUpdate, events.cartUpdate].filter(Boolean).forEach((name) => pubsub.subscribe(name, schedule));
    return true;
  };
  if (!subscribe()) document.addEventListener('DOMContentLoaded', subscribe, { once: true });
  // A price written into a display, or a button (re)rendered with one.
  const insidePrice = (node) => {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return Boolean(element && element.closest(DISPLAY));
  };
  const bringsPrice = (node) => node.nodeType === 1 && (node.matches(DISPLAY) || Boolean(node.querySelector(DISPLAY)));
  new MutationObserver((records) => {
    if (records.some((record) => insidePrice(record.target) || Array.from(record.addedNodes).some(bringsPrice))) schedule();
  }).observe(document.body, { subtree: true, childList: true, characterData: true });
  sync();
})();
